<div class="h-full w-full rounded-2xl shadow-lg overflow-hidden relative">
  <div *ngFor="let slide of slides; let i = index">
    <ts-picture [@inOutAnimation] class="inset-0 absolute shadow-lg z-10" *ngIf="i === currentIndex && !slide.bg_video"
      [img]="slide.bg_img"></ts-picture>
    <video (ended)="incIndex()" controls muted [@inOutAnimation] *ngIf="i === currentIndex && slide.bg_video" autoplay
      class="inset-0 absolute z-10" [src]="getVideoPath(slide.bg_video)"></video>
    <div class="absolute inset-0 bg-black"></div>
  </div>
</div>
